// Enum containing the different header heights
enum SubjectHeaderHeight {
  UNSTUCK = 79,
  STUCK = 39,
}

export default SubjectHeaderHeight;
